type CRTypes = {
  condition: boolean;
  children: any;
};

function ConditionalRenderer({ condition, children }: CRTypes) {
  return condition ? children : null;
}

export { ConditionalRenderer };
